import { format } from "date-fns";
import useSWR from "swr";
import { defaultSWROption } from "@/services/api/api.service";
import { VocService } from "@/services/voc/voc.service";

const NAMESPACE = "voc-char-count";

export const vocCharCountKey = (
  workspaceId: string,
  start: string,
  end: string,
) => [NAMESPACE, workspaceId, start, end] as const;

export const useVocCharCount = (
  workspaceId: string | null,
  start: Date | null,
  end: Date | null,
): { charCount: number | undefined; } => {
  const startStr = start ? format(start, "yyyy-MM-dd") : null;
  const endStr = end ? format(end, "yyyy-MM-dd") : null;

  const key = workspaceId && startStr && endStr
    ? vocCharCountKey(workspaceId, startStr, endStr)
    : null;

  const { data } = useSWR(
    key,
    () => VocService.getVocCharCount(workspaceId!, start!, end!),
    { ...defaultSWROption, keepPreviousData: true },
  );

  return { charCount: data };
};
